import React from 'react';
import { TColorRole, colorMap } from '../../types/types';
import { hexToRgb } from '../../utils/hexToRgb';

interface ITextCustomProps {
    children?: React.ReactNode;
    size?: number;
    color?: TColorRole;
    weight?: number;
    align?: React.CSSProperties['textAlign'];
    transparent?: number;
    breakText?: boolean;
    hasEllipsis?: boolean;
}

export const TextCustom: React.FC<ITextCustomProps> = ({ children, transparent = 1, size = 1, color = 'grey-normal', weight = 400, align = 'left', breakText = true, hasEllipsis = false }) => {
    const hexColor = colorMap[color] || colorMap['grey-normal'];
    const { r, g, b } = hexToRgb(hexColor);

    return (
        <div
            className="text"
            style={{
                wordWrap: 'break-word',
                wordBreak: `${breakText ? 'break-all' : 'normal'}`,
                color: `rgba(${r}, ${g}, ${b}, ${transparent})`,
                fontSize: `${size}rem`,
                fontWeight: `${weight}`,
                textAlign: `${align}`,
                overflow: hasEllipsis ? 'hidden' : 'visible',
                textOverflow: hasEllipsis ? 'ellipsis' : 'clip',
                whiteSpace: hasEllipsis ? 'nowrap' : 'normal',
            }}
        >
            {children}
        </div>
    );
};
